/** แสดงแบบย่อ (M) เมื่อมากกว่า 999,999 */
export const COMPACT_MONEY_THRESHOLD = 999_999;

export function isCompactMoneyAmount(amount: number): boolean {
  return Number.isFinite(amount) && amount > COMPACT_MONEY_THRESHOLD;
}

export function formatMoneyFullLabel(
  amount: number,
  locale = "lo-LA",
  currencyLabel = "ກີບ",
): string {
  const n = Number.isFinite(amount) ? amount : 0;
  return `${n.toLocaleString(locale)} ${currencyLabel}`;
}

/** ตัวเลขสำหรับแสดงบนการ์ด (ไม่รวมสกุลเงิน) */
export function formatCompactMoneyDisplay(
  amount: number,
  locale = "lo-LA",
): string {
  const n = Number.isFinite(amount) ? amount : 0;
  if (!isCompactMoneyAmount(n)) {
    return n.toLocaleString(locale);
  }

  const millions = n / 1_000_000;
  if (millions >= 100) {
    return `${Math.round(millions)}M`;
  }

  const rounded =
    millions >= 10
      ? Math.round(millions * 10) / 10
      : Math.round(millions * 10) / 10;

  const text =
    Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
  return `${text}M`;
}
